import type { DeliveryProfile } from '@/entities/sender.entity';

export type SenderApkDeliveryMethod = 'public_channel' | 'external_channel';

export const DEFAULT_SENDER_APK_DELIVERY_METHOD: SenderApkDeliveryMethod = 'public_channel';

export const SENDER_APK_DELIVERY_METHOD_OPTIONS: {
	value: SenderApkDeliveryMethod;
	label: string;
}[] = [
	{ value: 'public_channel', label: 'Свой канал + APK из билда' },
	{ value: 'external_channel', label: 'Последнее сообщение из канала' },
];

export function resolveSenderApkDeliveryMethod(
	value: string | null | undefined,
): SenderApkDeliveryMethod {
	return value === 'external_channel' ? 'external_channel' : 'public_channel';
}

export function shouldRequireBuildForCreateRun(method: SenderApkDeliveryMethod): boolean {
	return method === 'public_channel';
}

export function shouldRequireCaptionForCreateRun(method: SenderApkDeliveryMethod): boolean {
	return method === 'public_channel';
}

export function shouldRequireExternalChannelUrl(method: SenderApkDeliveryMethod): boolean {
	return method === 'external_channel';
}

export function resolveExternalChannelUrlFromSnapshot(
	snapshot: DeliveryProfile | undefined,
): string | null {
	if (snapshot?.delivery.source !== 'external_channel') return null;
	const url = snapshot.delivery.external_channel_url?.trim();
	return url || null;
}

export function isExternalChannelRun(snapshot: DeliveryProfile | undefined): boolean {
	return snapshot?.delivery.source === 'external_channel';
}

export function isLikelyExternalChannelUrl(value: string): boolean {
	const trimmed = value.trim();
	if (!trimmed || trimmed.length > 512) return false;
	if (/^@?[A-Za-z][A-Za-z0-9_]{3,31}$/.test(trimmed)) return true;
	if (/^(?:https?:\/\/)?(?:www\.)?t\.me\/[A-Za-z][A-Za-z0-9_]{3,31}$/i.test(trimmed)) return true;
	if (/^(?:https?:\/\/)?(?:www\.)?t\.me\/c\/\d+$/i.test(trimmed)) return true;
	return false;
}
